<template>
  <RecordTile v-if="!['ad', 'null-ad'].includes(tile.type)" :size="size" :tile="tile" :filters="filters"/>
  <AdTile v-else :size="size" :tile="tile"/>
</template>


<script setup>
import AdTile from "./AdTile.vue";
import RecordTile from "./RecordTile.vue";

const props = defineProps({
  tile: Object,
  size: String,
  filters: Object,
})

</script>
